import { Component, OnInit, Inject } from '@angular/core';
import { TslOverlayRef } from '@tesla/ng-tds';

@Component({
    selector: 'location-help-content',
    styleUrls: [],
    template: `<div class='content-overlay'><div style='width:400px;font-family:sans-serif'>
    <p style='padding:10px'>Asset status is tied with the demand status of the Associated Part Numbers. In order to update the Asset status, add the Associated Tesla Part Numbers and select the appropriate Asset status as:<br></p>
    <ul>
    <li> If any of the added parts have 'Production' demand status - choose Active. </li>
    <li> If any of the added parts have 'Service' demand status - choose Service. </li>
    <li> If any of the added parts have 'Future' demand status - choose Future. </li>
    <li> else choose Not Active (or Future if tool will soon be in use). <br>
    **If an Asset CMT is open, changes to location, associated parts and status cannot be made through profile until the CMT status is closed.</li>
    </ul></div></div>`
})

export class AssetStatusHelpContent {

    constructor(
        private overlayRef: TslOverlayRef<AssetStatusHelpContent>
    ) { }

    close() {
        this.overlayRef.close();
    }
}